module.exports = __webpack_public_path__ + "aff73c9408c9b5fb8e161551d46e1368.pdf";